export default __webpack_public_path__ + "static/media/iconResource.963b57ac.svg";